import { render, staticRenderFns } from "./SummaryElementContent.vue?vue&type=template&id=16b8d2fe"
import script from "./SummaryElementContent.vue?vue&type=script&lang=js"
export * from "./SummaryElementContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports